/**
 * A helper function to construct className strings conditionally.
 * @param clsx Object with key value pairs where key is the class name and value is a boolean
 * @returns string of class names that are true
 */
function buildClassNames<T extends { [key: string]: boolean }>(clsx: T) {
  return Object.entries(clsx).
    filter((group) => group[1]).
    map((group) => group[0]).join(' ');
}

const methodHelpers = {
  buildClassNames
};

export default methodHelpers;
